// extracted by mini-css-extract-plugin
module.exports = {"Preloader":"_8du8l","Preloader__Icon":"jKJLh","Preloader__Icon_small":"b8Fbx","Preloader__Circle":"ZGbpx","Preloader__Circle_animate":"_9lcns"};